import { UtilityService } from '../../../../common/services/Utility.service';
import { showPhoneNumberInString } from '../../../../common/utils/common';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

export enum AssignType {
  All,
  MyTicket,
  InGroup,
  Follow,
  MissedCall,
  NotTag,
  Open,
  InProcess,
  Completed,
  NearExpired,
  Campaign,
}

export const AssignList = [
  {
    id: AssignType.All,
    title: 'Tất cả',
  },
  {
    id: AssignType.MyTicket,
    title: 'Ticket của tôi',
  },
  {
    id: AssignType.Follow,
    title: 'Có tôi theo dõi',
  },
  {
    id: AssignType.InGroup,
    title: 'Thuộc bộ phận của tôi',
  },
];
export const AssignListAgent = [
  {
    id: AssignType.All,
    title: 'Tất cả',
  },
  {
    id: AssignType.Follow,
    title: 'Có tôi theo dõi',
  },
];

export const ExtendAssign = [
  {
    id: AssignType.Campaign,
    title: 'Ticket chiến dịch của tôi',
  },
  {
    id: AssignType.MissedCall,
    title: 'Ticket nhỡ',
  },
  {
    id: AssignType.Open,
    title: 'Ticket đang mở',
  },
  {
    id: AssignType.InProcess,
    title: 'Ticket đang xử lý',
  },
  {
    id: AssignType.Completed,
    title: 'Ticket đã hoàn thành',
  },
  {
    id: AssignType.NearExpired,
    title: 'Ticket sắp hết hạn',
  },
];

export function getParams(data: AssignType) {
  switch (data) {
    case AssignType.MyTicket:
      return 'me';
    case AssignType.InGroup:
      return 'group';
    case AssignType.Follow:
      return 'following';
    case AssignType.Campaign:
      return 'me';
    default:
      return 'all';
  }
}

export class SearchConst {
  static displayColumns = (
    fields: { title: string; key: string }[] = [],
    fieldsService: { title: string; key: string }[] = []
  ) => {
    let data: any = [
      {
        title: 'Mã Ticket',
        key: 'display_code',
        display: true,
        allowSort: false,
        classes: '',
        field: 'code',
      },
      {
        title: 'Chủ đề',
        key: 'display_subject',
        display: true,
        allowSort: false,
        classes: '',
        field: 'subject',
      },

      {
        title: 'Tổ chức',
        key: 'display_organization',
        display: true,
        allowSort: false,
        classes: '',
        field: 'organize',
      },
      {
        title: 'Người yêu cầu',
        key: 'display_requester',
        display: true,
        allowSort: false,
        classes: '',
        field: 'customer_name',
      },
      {
        title: 'Chuyên viên',
        key: 'display_assignee',
        display: true,
        allowSort: false,
        classes: '',
        field: 'agent_name',
      },
      {
        title: 'Theo dõi',
        key: 'display_follow_users',
        display: false,
        allowSort: false,
        classes: '',
        field: 'agent_following',
      },
      {
        title: 'Cc',
        key: 'display_cc_users',
        display: false,
        allowSort: false,
        classes: '',
        field: 'cc',
      },
      {
        title: 'Nguồn',
        key: 'display_source',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'source_detail',
      },
      {
        title: 'Trạng thái',
        key: 'display_status',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'status',
      },
      {
        title: 'Thời gian khởi tạo',
        key: 'display_created_at',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'created_at',
      },
      {
        title: 'Cập nhật lần cuối',
        key: 'display_updated_at',
        display: true,
        allowSort: false,
        classes: 'text-center',
        field: 'updated_at',
      },
      {
        title: 'Độ ưu tiên',
        key: 'display_priority',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'priority_id',
      },
      {
        title: 'Phân loại',
        key: 'display_type',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'type_id',
      },
      {
        title: 'Thời hạn xử lý',
        key: 'display_duedate',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'duedate',
      },

      {
        title: 'Tag',
        key: 'tags',
        display: false,
        allowSort: false,
        classes: 'text-center',
        field: 'tags',
      },
    ];
    if (fieldsService) {
      fieldsService.forEach(f => {
        data.push({
          title: f.title,
          key: 'display_' + f.key,
          display: false,
          allowSort: false,
          classes: '',
          field: f.key,
        });
      });
    }
    if (fields.length > 0) {
      fields.forEach(f => {
        data.push({
          title: f.title,
          key: 'display_' + f.key,
          display: false,
          allowSort: false,
          classes: '',
          field: f.key,
        });
      });
    }
    return data;
  };

  static displayOrganizationColumns = (item, allOrganization) => {
    const organization = allOrganization.find(e => {
      if (item.request && item.request.organize_id) {
        return e.organize_id == item.request.organize_id;
      }
    });
    return organization ? organization.name : 'Chưa xác định';
  };

  static displayFieldColumn = (data, t) => {
    if (!data) return '';
    return data[t.key]
      ? t.type === 'date'
        ? moment(data[t.key]).add('-7', 'hours').format('YYYY-MM-DD HH:mm')
        : data[t.key]
      : '';
  };
  static displayCodeColumns = item => {
    return `<a class="text_link" href="javascript:void(0)">${item.code}</a>`;
  };
  static displaySubjectColumns = (item, user) => {
    return item.subject ? showPhoneNumberInString(item.subject, user) : '';
  };
  static displayRequesterColumns = (item, user) => {
    if (item) {
      return item.name
        ? showPhoneNumberInString(item.name, user)
        : item.phone
          ? showPhoneNumberInString(item.phone, user)
          : item.email
            ? item.email
            : '';
    }
    return ``;
  };

  static displayUsersColumns = (item, allAgent) => {
    if (typeof item === 'string') {
      item = item.split(',');
    }
    if (item) {
      return item
        .map(e => {
          const agent = allAgent.find(agent => agent.id == e);
          return agent ? agent.text : '';
        })
        .join(', ');
    } else {
      return '';
    }
  };

  static displayAssigneeColumns = (item, agents) => {
    const agent = agents.find(agent => agent.id == item.assign_agent_id);
    return agent
      ? agent.text
      : item.assignee
        ? item.assignee.name
        : item.assign_agent
          ? item.assign_agent.name
          : 'Chưa xác định';
  };
  static displaySourceColumns = item => {
    switch (item.source) {
      case 'call':
        if (item.source_detail == 'CALL_INBOUND') {
          return `<i><img src="../../../../../assets/icons/in-coming-1.svg" alt=""/></i>`;
        }
        if (item.source_detail == 'CALL_OUTBOUND') {
          return `<i><img src="../../../../../assets/icons/out-going-1.svg" alt=""/></i>`;
        }
        break;
      case 'email':
        return `<i class="icon fa fa-envelope"></i>`;
      case 'web':
        switch (item.source_detail) {
          case 'facebook':
            return `<i class="icon fa fa-facebook"></i>`;
          case 'zalo':
            return `<i><img src="../../../../../assets/images/zalo-black.png" width="16" alt=""/></i>`;
          default:
            return `<i class="icon fa fa-comments"></i>`;
        }
      case 'hand':
        return `<i class="icon fa fa-edit"></i>`;
      case 'sms':
        return `<i class="icon fa fa-commenting-o"></i>`;
      case 'zalo':
        return `<i><img src="../../../../../assets/images/zalo-black.png" width="16" alt=""/></i>`;
      default:
        return '';
    }
  };
  static displayStatusColumns = item => {
    switch (item.status) {
      case 1:
      case '1':
        return `<span class="badge badge-danger mr-5">Mới</span`;
      case 2:
      case '2':
        return `<span class="badge badge-info mr-5">Đang xử lý</span`;
      case 3:
      case '3':
        return `<span class="badge badge-primary mr-5">Đã xử lý</span`;
      case 4:
      case '4':
        return `<span class="badge badge-danger mr-5">Mở lại</span`;
      case 5:
      case '5':
        return `<span class="badge badge-dark mr-5">Đã đóng</span`;
    }
  };
  static displayTimeColumns = time => {
    return UtilityService.dateFormat(time, { isMessage: true, message: '' });
  };
  static displayPriorityColumns = (item, allPriority) => {
    const priority = allPriority.find(p => p.id == item);
    return priority ? priority.name : '';
  };

  static displayTypeColumns = (item, allType) => {
    const type = allType.find(t => t.id == item);
    return type ? type.name : '';
  };

  static displayServiceColumns = (item, allService) => {
    const service = allService.find(s => s.id == item);
    return service ? service.name : '';
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/search/search.const.ts